import Axios from "../util/axiosInstance";

export const getUserInfo = (instrId, isPublicPreview = false) => {
  if (instrId) {
    return Axios.get(`/api/TrainerProfile/Get?instrId=${instrId}${isPublicPreview ? '&isPublicPreview=true' : ''}`)
  }
  return Axios.get(`/api/TrainerProfile/Get${isPublicPreview ? '?isPublicPreview=true' : ''}`)
};

export const postPreferenceApi = (payload) => {
  return Axios.post("/api/TrainerProfile/UpdatePreferences", payload)
 
};